import { TOP_NAV_HEIGHT } from 'style/dimensions';

import Row from 'components/UIKit/Flex/Row';
import Label from 'components/UIKit/Label';
import Spinner from 'components/UIKit/Spinner/Spinner';
import DashboardIcon from 'components/icons/DashboardIcon';
import TransactionIcon from 'components/icons/TransactionIcon';
import SearchIcon from 'components/icons/SearchIcon';
import OpenIcon from 'components/icons/OpenIcon';
import ReviewIcon from 'components/icons/ReviewIcon';
import SubmittedIcon from 'components/icons/SubmittedIcon';
import WarningIcon from 'components/icons/WarningIcon';

import { DARK_GREY } from 'style/colors';

import {
  StyledInternalLink,
  HomeLink,
} from 'components/Links';

const TopNavigation = ({
  location,
  project,
}) => {
  const activePath = path => location.pathname.includes(path);

  return (
    <Row
      className="no-print"
      style={{
        height: `${TOP_NAV_HEIGHT}rem`,
        justifyContent: 'center',
        backgroundColor: '#fefefe',
        borderBottom: '1px solid #e5e5e5',
      }}
      >
      <Row style={{ width: '67rem', alignItems: 'center', justifyContent: 'space-between' }}>
        <Row style={{ alignItems: 'flex-end', fontSize: '1.3rem' }}>
          {project.request_submission
            ? <SubmittedIcon style={{ marginRight: '1rem', color: '#a1882b' }} />
            : project.in_review
              ? <ReviewIcon style={{ marginRight: '1rem', color: '#a1882b' }} />
              : <OpenIcon style={{ marginRight: '1rem', color: '#666' }} />}

          <HomeLink customDataTestID="button-projects-return-home" >Projects</HomeLink>
&nbsp;/&nbsp;

          {activePath('dashboard')
            ? project.project_id
            : (
              <StyledInternalLink
                destination="dashboard"
                style={{ padding: 0 }}
                withProjectPath
                >
                {project.project_id}
              </StyledInternalLink>
              )}

          {project.isSubmitting && (
            <Row>
              <Label style={{ color: '#a1882b', backgroundColor: '#ffefc6', marginRight: '1rem' }}>SUBMITTING</Label>
              <Spinner />
            </Row>
          )}

          {!project.isSubmitting && (
            project.request_submission
            ? <Label style={{ color: 'black', backgroundColor: '#ffefc6' }}>HARMONIZATION REQUESTED</Label>
            : project.in_review
              ? <Label style={{ color: 'black', backgroundColor: '#ffefc6' }}>REVIEW</Label>
              : <Label style={{ color: 'blue', backgroundColor: 'skyblue' }}>OPEN</Label>)}
        </Row>

        <Row data-testid="header-tabs" style={{ alignSelf: 'flex-end' }}>
          <StyledInternalLink data-testid="button-tab-dashboard" className="tab" destination="dashboard" withProjectPath>
            <DashboardIcon style={{ marginRight: '0.5rem' }} />
            Dashboard
          </StyledInternalLink>
          <StyledInternalLink data-testid="button-tab-transactions" className="tab" destination="transactions" withProjectPath>
            <TransactionIcon style={{ marginRight: '0.5rem' }} />
            Transactions
          </StyledInternalLink>
          <StyledInternalLink data-testid="button-tab-browse" className="tab" destination="browse" withProjectPath>
            <SearchIcon style={{ marginRight: '0.5rem' }} />
            Browse
          </StyledInternalLink>
          <StyledInternalLink data-testid="button-tab-qc-report" className="tab" destination="qc" withProjectPath>
            <WarningIcon style={{ marginRight: '0.5rem' }} color={DARK_GREY} />
            QC Report
          </StyledInternalLink>
        </Row>
      </Row>
    </Row>
  );
};

export default TopNavigation;
